var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "asc__insertPage" },
    [
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "header",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "6" } },
                  [_c("Breadcrumb")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "text-right", attrs: { cols: "12", md: "6" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "ItemAnalysis" } } },
                      [_c("CancelButton")],
                      1
                    ),
                    _vm._v(" "),
                    _c("AddButton", {
                      nativeOn: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "asc__insertPage-content-head", attrs: { cols: "12" } },
        [
          _c(
            "section",
            [
              _c(
                "b-row",
                [
                  _c(
                    "NextFormGroup",
                    { attrs: { "item-key": "Code", error: _vm.$v.form.Code } },
                    [
                      _c("NextInput", {
                        attrs: { type: "text", disabled: _vm.isDisabled },
                        model: {
                          value: _vm.form.Code,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Code", $$v)
                          },
                          expression: "form.Code"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "Description1",
                        error: _vm.$v.form.Description1
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: { type: "text", disabled: _vm.isDisabled },
                        model: {
                          value: _vm.form.Description1,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Description1", $$v)
                          },
                          expression: "form.Description1"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "StatusId",
                        error: _vm.$v.form.StatusId
                      }
                    },
                    [
                      _c("NextCheckBox", {
                        attrs: {
                          type: "number",
                          toggle: "",
                          disabled: _vm.insertReadonly.StatusId
                        },
                        model: {
                          value: _vm.form.StatusId,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "StatusId", $$v)
                          },
                          expression: "form.StatusId"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-tabs",
            [
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t("insert.itemAnalysis.title"),
                    active: ""
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.tabValidation()
                    }
                  }
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "ValidityTypeId",
                            error: _vm.$v.form.ValidityTypeId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.isDisabled,
                              "lookup-key": "ANALYSIS_VALIDITY_TYPE"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "ValidityTypeId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.validityType,
                              callback: function($$v) {
                                _vm.validityType = $$v
                              },
                              expression: "validityType"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "AnalysisTypeId",
                            error: _vm.$v.form.AnalysisTypeId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.isDisabled,
                              "lookup-key": "ITEM_ANALYSIS_TYPE"
                            },
                            on: {
                              input: function($event) {
                                _vm.selectedType("AnalysisTypeId", $event)
                                _vm.setUseOnce($event)
                              }
                            },
                            model: {
                              value: _vm.analysisType,
                              callback: function($$v) {
                                _vm.analysisType = $$v
                              },
                              expression: "analysisType"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "AnalysisPeriodId",
                            error: _vm.$v.form.AnalysisPeriodId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.isDisabled,
                              "lookup-key": "ANALYSIS_PERIOD"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "AnalysisPeriodId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.analysisPeriod,
                              callback: function($$v) {
                                _vm.analysisPeriod = $$v
                              },
                              expression: "analysisPeriod"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "ApproveStateId",
                            error: _vm.$v.form.ApproveStateId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.ApproveStateId,
                              "lookup-key": "APPROVE_STATE"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "ApproveStateId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.approveState,
                              callback: function($$v) {
                                _vm.approveState = $$v
                              },
                              expression: "approveState"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "AnalysisVisitCount",
                            error: _vm.$v.form.AnalysisVisitCount
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "number", disabled: _vm.isDisabled },
                            model: {
                              value: _vm.form.AnalysisVisitCount,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "AnalysisVisitCount", $$v)
                              },
                              expression: "form.AnalysisVisitCount"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "CustomerCriteriaId",
                            error: _vm.$v.form.CustomerCriteriaId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.CustomerCriteriaId,
                              source: _vm.lookup.CUSTOMER_CRITERIA
                                ? _vm.lookup.CUSTOMER_CRITERIA.filter(function(
                                    c
                                  ) {
                                    return c.Code != "MS"
                                  })
                                : [],
                              label: "Label"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "CustomerCriteriaId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.customerCriteria,
                              callback: function($$v) {
                                _vm.customerCriteria = $$v
                              },
                              expression: "customerCriteria"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "ItemCriteriaId",
                            error: _vm.$v.form.ItemCriteriaId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.isDisabled,
                              source: _vm.lookup.ITEM_CRITERIA
                                ? _vm.lookup.ITEM_CRITERIA.filter(function(c) {
                                    return c.Code == "TU" || c.Code === "UL"
                                  })
                                : [],
                              label: "Label"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "ItemCriteriaId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.itemCriteria,
                              callback: function($$v) {
                                _vm.itemCriteria = $$v
                              },
                              expression: "itemCriteria"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "IsNecessary",
                            error: _vm.$v.form.IsNecessary
                          }
                        },
                        [
                          _c("NextCheckBox", {
                            attrs: {
                              type: "number",
                              toggle: "",
                              disabled: _vm.insertReadonly.IsNecessary
                            },
                            model: {
                              value: _vm.form.IsNecessary,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "IsNecessary", $$v)
                              },
                              expression: "form.IsNecessary"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "UseOnce",
                            error: _vm.$v.form.UseOnce
                          }
                        },
                        [
                          _c("NextCheckBox", {
                            attrs: {
                              type: "number",
                              toggle: "",
                              disabled:
                                !_vm.analysisType ||
                                _vm.analysisType.Code !== "KLN" ||
                                _vm.isDisabled
                            },
                            model: {
                              value: _vm.form.UseOnce,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "UseOnce", $$v)
                              },
                              expression: "form.UseOnce"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "SortOrder",
                            error: _vm.$v.form.SortOrder
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "number",
                              disabled: _vm.isDisabled,
                              maxLength: "2",
                              oninput: _vm.maxLengthControl
                            },
                            model: {
                              value: _vm.form.SortOrder,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "SortOrder", $$v)
                              },
                              expression: "form.SortOrder"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "AnalysisTimeId",
                            error: _vm.$v.form.AnalysisTimeId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.isDisabled,
                              "lookup-key": "ANALYSIS_TIME"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "AnalysisTimeId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.analysisTime,
                              callback: function($$v) {
                                _vm.analysisTime = $$v
                              },
                              expression: "analysisTime"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                {
                  attrs: {
                    lazy: "",
                    title: _vm.$t("insert.itemAnalysis.analysisQuestions")
                  }
                },
                [
                  _c("NextDetailPanel", {
                    attrs: {
                      type: _vm.isDisabled ? "get" : "update",
                      items: _vm.itemAnalysisQuestionItems,
                      "has-line-number": true
                    },
                    model: {
                      value: _vm.form.ItemAnalysisQuestions,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "ItemAnalysisQuestions", $$v)
                      },
                      expression: "form.ItemAnalysisQuestions"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: _vm.$t("insert.itemAnalysis.branchs") } },
                [
                  _c("NextDetailPanel", {
                    attrs: { items: _vm.itemAnalysisBranchItems },
                    model: {
                      value: _vm.form.ItemAnalysisBranches,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "ItemAnalysisBranches", $$v)
                      },
                      expression: "form.ItemAnalysisBranches"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                {
                  attrs: {
                    lazy: "",
                    title: _vm.$t("insert.itemAnalysis.employeeType")
                  }
                },
                [
                  _c("NextDetailPanel", {
                    attrs: {
                      type: _vm.isDisabled ? "get" : "update",
                      items: _vm.itemAnalysisEmployeeItems
                    },
                    model: {
                      value: _vm.form.ItemAnalysisEmployeeTypes,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "ItemAnalysisEmployeeTypes", $$v)
                      },
                      expression: "form.ItemAnalysisEmployeeTypes"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.validityType && _vm.validityType.Code === "SS"
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        lazy: "",
                        title: _vm.$t("insert.itemAnalysis.validDates")
                      }
                    },
                    [
                      _c("NextDetailPanel", {
                        attrs: {
                          type: _vm.isDisabled ? "get" : "update",
                          items: _vm.itemAnalysisValidDateItems,
                          "before-add": _vm.beforeValidDatesAdd
                        },
                        model: {
                          value: _vm.form.ItemAnalysisValidDates,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "ItemAnalysisValidDates", $$v)
                          },
                          expression: "form.ItemAnalysisValidDates"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.itemCriteria && _vm.itemCriteria.Code === "UL"
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        lazy: "",
                        title: _vm.$t("insert.itemAnalysis.itemList")
                      }
                    },
                    [
                      _c("NextDetailPanel", {
                        attrs: {
                          type: _vm.isDisabled ? "get" : "update",
                          items: _vm.itemAnalysisItems
                        },
                        model: {
                          value: _vm.form.ItemAnalysisItems,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "ItemAnalysisItems", $$v)
                          },
                          expression: "form.ItemAnalysisItems"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.customerCriteria && _vm.customerCriteria.Code === "ML"
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        lazy: "",
                        title: _vm.$t("insert.itemAnalysis.customerList"),
                        disabled:
                          !_vm.form.ItemAnalysisBranches ||
                          _vm.form.ItemAnalysisBranches.length === 0
                      }
                    },
                    [
                      _c("NextDetailPanel", {
                        attrs: { items: _vm.itemAnalysisCustomerItems },
                        model: {
                          value: _vm.customers,
                          callback: function($$v) {
                            _vm.customers = $$v
                          },
                          expression: "customers"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.customerCriteria && _vm.customerCriteria.Code === "MK"
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        lazy: "",
                        title: _vm.$t("insert.itemAnalysis.customerCriterias")
                      }
                    },
                    [
                      _c("NextDetailPanel", {
                        attrs: { items: _vm.itemAnalysisDetailItems },
                        model: {
                          value: _vm.customerCriterias,
                          callback: function($$v) {
                            _vm.customerCriterias = $$v
                          },
                          expression: "customerCriterias"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e6876756", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e6876756","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ItemAnalysis/update.vue
// module id = null
// module chunks = 